import { render, staticRenderFns } from "./userAgree.vue?vue&type=template&id=dfcf25aa&scoped=true"
import script from "./userAgree.vue?vue&type=script&lang=js"
export * from "./userAgree.vue?vue&type=script&lang=js"
import style0 from "./userAgree.vue?vue&type=style&index=0&id=dfcf25aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcf25aa",
  null
  
)

export default component.exports